<template>
  <div class="enterpriser">
    <section class="main">
      <!-- <div class="bread">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>关于粒上皇</el-breadcrumb-item>
          <el-breadcrumb-item>企业家风采</el-breadcrumb-item>
        </el-breadcrumb>
      </div> -->

      <!-- 员工风采 -->
      <div class="article">
        <h1>粒上皇领航者潘俊海：粒眼观世界，一事终一生</h1>
        <img src="../assets/img/enterpriser/ceo1.jpg" alt />
        <h3>背负梦想，勇闯天涯</h3>
        <p class="margin20">1979年，潘俊海出生于安徽阜阳，家中四子排行老二。大哥很早便过继于大伯家中，潘俊海实际上承担了家中长子的责任与重担。从小勤奋刻苦，加之天资聪颖，学习成绩在班中始终名列前茅，但是“高考”却成了潘俊海心中永远的痛。因父母无法支付高昂的大学学费，潘俊海不得不忍痛放弃难能可贵的高考机会，眼看自己梦寐以求的学习深造机会近在咫尺，却也只有挥泪道别。虽然儿时的生活极为艰辛，但潘俊海却说：我们无法选择自己的出身和家境，但可以掌握成年后的人生命运，一切磨难都是最好的安排。</p>
		<p>面对人生重大打击的潘俊海没有丝毫气馁，而是整理好行囊，带着东拼西凑的些许零钱，踏上了前往北京的征途。人生地不熟，没有殷实的背景、没有过硬的学历、没有任何人脉资源，来京北漂的潘俊海唯一能依靠的只有自己勤劳的双手和不屈不挠的品质。起初工作还未有着落之时，他曾蜷缩在漆黑阴冷的六里桥桥洞里整晚，也曾斜倚在马路边上度过漫长之夜，寻找工作也处处碰壁。
	几经周折寻找到的第一份工作也是与板栗毫无关联的建筑工作。消瘦单薄的身体要扛起几十公斤重的水泥、建筑材料，每天起早贪黑，搬上卸下。就这样，他成为了工地里的“劳动模范”，从不歇息白班最多、晚上加班也最多、更是打破了工地上一个月加班时间最长的纪录，但是潘俊海对此无怨无悔，那时的他已经立下狠誓：一定要出人头地、让自己的家人过上衣食无忧的好日子！</p>
        <h3>偶然机遇，与栗结缘</h3>
        <p class="margin20">也正是凭着这一股初生牛犊不怕虎的倔强，潘俊海在一次机缘巧合下认识了当时在夜市做板栗生意的安徽老乡。或许是独在异乡为异客的惺惺相惜，也或许是老乡被潘俊海吃苦耐劳的品质所打动，决定让年轻的潘俊海协同一起做板栗生意。当初对潘俊海而言的一次偶然机遇，竟然促成了他与板栗的不解情缘。农村出身的潘俊海毫不畏惧这个陌生的城市，每天用心炒着板栗、大声叫卖着。3个月后又随同这位老乡一同前往青岛，准备在这个全新的城市大展拳脚，他要把小小的板栗生意做大做强！</p>
        <p>
         但由于对新兴市场的准备不当，老乡的板栗生意因市场萎靡严重下滑。面对青岛萧条的市场，潘俊海却没有选择做“逃兵”，在这位老乡离去后，决定撸起袖子单打独斗，在青岛闯出一片新天地。为筹措最初的启动资金，他动用了所有可能的人脉关系，挨家挨户筹款集资，虽然听到不少冷言冷语，但潘俊海知道万事开头难，一定要坚持！
        </p>
		<p class="margin20">但是，费尽周折凑到的2000元却只是杯水车薪，连添置设备的钱都不够，只能勉强采购少量的原料。面对层出不穷的困难，潘俊海用智慧一一化解：他先是靠部分赊欠的方式，向供货商进了一批货，又与门面的房东商量，用利润分成的方式冲抵房租。为了减少开支，潘俊海对自己极为“吝啬”，省吃俭用、粗茶淡饭、匆匆果腹。但很快，他的付出终于有了回报：板栗店的生意逐渐走向正轨，曙光似乎就在眼前，触手可得。但好景不长，贪心的房东却要求收回店面自立门户，举目无亲、人单势孤的小年轻在此困境下，潘俊海只有选择忍辱负重，尽量做到全身而退。虽然，在青岛所受的“重创伤口”还未抚平，潘俊海却又马不停蹄前往温州，寻找更好的机遇。</p>
        <img src="../assets/img/enterpriser/ceo2.jpg" alt />
        <h3>越挫越勇，迎难而上</h3>
        <p class="margin20">
         当时光退回到2000年的温州，由于潘俊海始终如一的诚实守信，他的供货商付先生慷慨解囊，在潘俊海最困难的时候赊欠给他10多万元的原料。这个数字在如今看来，并不庞大，但是在当时当下，却是对潘俊海最大的支持与鼓励。由于当时温州炒栗子的市场还未充分开发，潜力无限，潘俊海在那里获得了意想不到的成功，更获得了人生的第一桶金。在半年多的时间里，潘俊海在温州逐渐站稳了脚跟，4家门店陆续开出，每一家门口都人头攒动，大排长龙。潘俊海只用了半年的时间便还清了所有欠款、添置了新设备、并采购了充足的原料。
        </p>
		<p class="margin20">除了年轻人的一腔热血，潘俊海的身上更有审时度势的大视野。温州的市场发展得再好，也仅是一隅之地，终有饱和之时，极富前瞻性、和具有先见之明的潘俊海决定一鼓作气,到更广阔的市场去开辟他的“板栗王国”。</p>
        <p>
          千禧年的10月，满怀雄心壮志的潘俊海怀揣在温州辛苦挣来的利润与贷款借来的9万元，踏上了前往广州的寻梦之旅。年轻气盛的潘俊海自认为只要继续努力，一定能在广州收获更好的成绩，但却未料，由于当年板栗市场原料严重缺乏，潘俊海非但没有任何盈利，还亏了整整5万多元！从满怀希望到身无分文，负债累累，潘俊海在广州遭遇了最惨痛的打击。这不仅是一次生意场上的滑铁卢，更让与其一同前往广州发展的团队感到无路可走。
        </p>
		<p class="margin20">面对窘迫的状况，坚韧的潘俊海重新振作，决定从档口小铺转战商超渠道。慢慢地，凭借自己的倔强不息与持之以恒，潘俊海终于扭转了自己的命运，产能、销量都在增长。但是却未料到，贪心的渠道供应商竟然携款潜逃，他带走的不仅是潘俊海用汗水打拼而来一分一毫的辛苦钱，更是潘俊海踌躇满志的未来，命运再次给他带来巨大的挑战。除了极大的精神压力外，潘俊海当时更背负了30万元的高额负债。</p>
		<p class="margin20">也正是当时的这一道坎，让他清楚地意识到不能止步于板栗生产供应商的身份，没有自己的品牌、没有自己的顾客群体、没有自己的产品，依附于他人的渠道平台，就永远没有自己的核心竞争力！所以，在2005年下半年，潘俊海顶着重压四处借款，终于如愿以偿创立了自己的板栗品牌“栗上皇”。</p>
		<h3>匠人精神，匠心品质</h3>
        <p class="margin20">
          字如其名，“栗上皇”是一种使命，更是一种责任:潘俊海要打造自己的板栗品牌，从采购到物流，从鉴别到筛选，从炒制到销售，让每颗板栗都如同皇室珍宝般传递给顾客。每一粒都是精挑细选、毫无瑕疵的珍品；每一粒都是入口即化、粉糯飘香的美味，照亮食客们从指尖到心灵的美味路径。
        </p>
		<p class="margin20">早期的“栗上皇”与其说是一个品牌，更像是一个个抢占市场先机的小作坊。没有整齐划一的工作服，没有系统完善的服务培训，即使如此，原生态的“栗上皇”还是每天宾客盈门，成了广州当时较接地气的零食。潘俊海始终恪守匠心精神，质量就是生命，品质决定一切！为了保证每一颗板栗都是精挑细选的上品，不遗余力地抓好每一个生产环节，亲力亲为，带着团队到板栗供应地河北亲自挑选。没有机器辅助的创业初期，每一颗板栗都是潘俊海与团队手工筛选，保证食客口中的板栗没有一个是瑕疵品。</p>

        <p class="margin20">不到四年时间，潘俊海一手打造的“栗上皇”炒货店在美食天堂广州就迅速发展到20多家分店，虽然发展过程中不断有竞争对手效仿，刻意复制经营模式，甚至选择和“栗上皇”极为相似的名称，但那一份始终坚守的匠心精神却是无法套用和因袭。在不断的竞争中，门店售卖的产品也由之前单一的炒栗子扩展到瓜子、花生、核桃等多种干果炒制产品，“栗上皇”也就此更名为如今让人有口皆碑的“粒上皇”。</p>
        <p>潘俊海抓住机遇，顺势而为，紧锣密鼓地建立了高素质的原料采购团队，培训了火眼金睛的检验人才，每年8月底带领百余人前往原料地进行极为严苛的原料采购。带领团队始终恪守匠人精神，在原料地先做第一轮的收购挑选，再由公司专业的监察人员再次筛查，保证没有“漏网之鱼”。将近乎同一品质、大小的板栗运输到生产基地，通过机器和人工双管齐下的方式做第三轮、第四轮精益求精的质量检测。
		在保证没有瑕疵品的情况下将优质的板栗打包放进冷库分配到各个门店。板栗进入到门店后还要进行至少两轮的人工检查。炒制前后，每一个门店人员为了保证“粒上皇”的品质，都会全力以赴把控好产品的最后一道质量关。所以，即使在生活节奏如此快速的当代，各类街边美食层出不穷的城市里，我们仍会看到“粒上皇”店门外大排长龙的景象，它也成为了北京、上海、广州、深圳等城市的一道靓丽风景线。</p>
        <div class="flex imgbox">
          <img src="../assets/img/enterpriser/ceo3.jpg" alt />
          <img src="../assets/img/enterpriser/ceo4.jpg" alt />
        </div>
        <h3>宏图伟业，永不止步</h3>
        <p>
         回顾过去，“粒上皇”发展的每一年每一步都让潘俊海记忆犹新。也是从“粒上皇”开始国内掀起了 “新传统”零食的一场全新革命，在更开放、更时尚、更前卫的休闲食品消费空间内，在古法基础上坚持新鲜无添加的匠心之本，改良出更适合现代年轻人口味的美味零食。
        </p>
		<p class="margin20">下一个5年对于“粒上皇”而言是具有跨时代意义的5年，“传承民族精神，坚持匠心品质，弘扬中华美食”，走出国门，走向世界，争取让美味而健康的绿色休闲零食“粒上皇”成为跨越种族、跨越国界，世界人民共通的“语言”。“今天，你吃粒上皇了吗？”相信这样一句寒暄之语将会成为打招呼的通语，更期待着“粒上皇”在不久的将来，成为我们每家每户茶余饭后必备的休闲零食。而“粒上皇”也不再只是一个产品，一个品牌，而是代表一种民族精神，将被继续传承，共享，延续并发扬光大。 </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.enterpriser {
  .article {
    width: 1000px;
    margin: 0 auto;
    text-align: justify;
    h1 {
      font-family: 'HarmonyOS Sans SC';
      font-size: 44px;
      color: #333333;
      padding: 52px 0;
    }
    > img {
      width: 100%;
      margin-bottom: 40px;
      border-radius: 8px;
    }
    h3 {
      font-family: 'HarmonyOS Sans SC';
      font-size: 18px;
      color: #333333;
      font-weight: 500;
      margin-bottom: 12px;
    }
    p {
      font-family: 'HarmonyOS Sans SC';
      font-size: 14px;
      color: #000000;
      line-height: 30px;
      margin-bottom: 30px;
      text-indent: 25px;
    }
    .margin20{
        margin-bottom: 20px;
    }
    .imgbox {
      justify-content: space-between;
      img {
        width: 485px;
        height: 324px;
        border-radius: 8px;
        margin-bottom: 40px;
      }
    }
  }
}
</style>
<style lang="scss">
.bread,
.el-breadcrumb {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #fafafa;
}
.el-breadcrumb {
  width: 1200px;
  margin: 0 auto;
}
</style>
